module.exports = __webpack_public_path__ + "img/MX-B024035A-AS.7b5a9a41.png";